export default __webpack_public_path__ + "static/media/uncheck.0bade77e.png";